export default __webpack_public_path__ + "static/media/active-users.211879a7.svg";